export const AVAILABLE_PRODUCTS_ORDERING = [
  /** mens */
  'chrissy-chungus',
  'grouse-chips',
  'cactus-bizzo',
  'ripper-rissole',
  'whinging-magpie',
  'aggro-emu',
  'outback-brolly',
  'sooky-sanga',
  'fair-cuppa',
  'jumping-boot',
  'shouty-pav',
  'cluey-kookaburra',
  'tall-larrikin',
  'unreal-chinwag',
  'cheeky-cockatoo',
  'bonza-lamington',
  'billowing-parachute',
  'billowing-falsehood',
  'billowing-swelter',
  /** womens */
  'dodgy-dooverlackie',
  'dinkum-bandicoot',
  'wonky-mozzie',
  'peckish-flannel',
  'flaming-ute',
  'blockish-wrapper',
  /** stickers */
  'sticky-runners',
  'lofty-lifesavers',
  'glitzy-clinger',
  'dodgy-bonnet',
  'ropeable-gumtree',
  'overland-bikkies',
  /** device cases */
  'top-jaffle',
  'double-magpie',
  'rough-sultana',
  'lovely-dingo',
  'cranky-beetroot',
  'whinging-rissole',
  'wagging-grub',
  'bush-brolly',
  'bush-magpie',
  'furphy-fiddlesticks',
  'tassie-wallaroo',
  /** print */
  'shifting-brolly',
  'strewn-joey',
  'outback-mate',
  'googy-veggies',
  'fair-garage',
  'crooked-lamington',
  'beaut-flannel',
  'shouty-flannel',
  /** decor (home living) */
  'barracking-ute',
  'drain-doco',
  'ridgy-crumpet',
  'country-dill',
  'shouty-pressies',
  'icky-garage',
  'frostie-sunnies',
  'tinnie-telly',
  'bush-fizzer',
  /** kids */
  'big-wheelie',
  'decent-cuppa',
  'chewy-drongo',
  'tall-sock',
  'cracker-kangaroo',
  'aussie-hooroo',
  /** accessories */
  'aggro-clanger',
  'minty-serviette',
  'choccy-swag',
  'wagging-shemozzle',
  'brass-boglin',
  'heaps-freshie',
  'jelly-drop', // pin
  'unreal-bit',
  'big-chockie',
  'beaut-galah',
  'chewy-runners',
  'devo-croc',
  'sooky-chinwag',
  /** stationery */
  'frostie-brizzie',
  'ripper-brat',
  'whinging-koala',
  /** rest */
  'choccy-tucker',
  'gnarly-seesaw',
  'bluey-gromit', // die cut magnet
];

export const CANONICAL_GROUPS = {
  STICKERS: [
    'sticky-runners',
    'lofty-lifesavers',
    'overland-bikkies',
    'glitzy-clinger',
  ],
  TSHIRTS: [
    'cluey-kookaburra',
    'grouse-chips',
    'wonky-mozzie',
    'outback-brolly',
    'jumping-boot',
    'shouty-pav',
    'tall-larrikin',
    'cheeky-cockatoo',
    'bonza-lamington',
    'cactus-bizzo',
    'ripper-rissole',
    'unreal-chinwag',
    'flaming-ute',
    'dinkum-bandicoot',
    'sooky-sanga',
    'peckish-flannel',
    'billowing-parachute',
    'blockish-wrapper',
  ],
  IPHONE_CASES: [
    'cranky-beetroot',
    'lovely-dingo',
    'whinging-rissole',
    'rough-sultana',
    'ferric-fortifier',
  ],
  SAMSUNG_CASES: ['furphy-fiddlesticks', 'tassie-wallaroo', 'bush-magpie'],
  MUGS: ['wagging-shemozzle', 'beaut-galah'],
  KIDS_CLOTHES: [
    'chewy-drongo',
    'tall-sock',
    'cracker-kangaroo',
    'decent-cuppa',
  ],
};
